module.exports = __webpack_public_path__ + "img/msc.4eee3bee.webp";